import importerDocumentGenerator from "../../core/chrome/importerDocumentGenerator.js";
import importWizardDocument from "./importWizardDocument.js";

export default importerDocumentGenerator(importWizardDocument);
